
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimbel/register-trial",
      function () {
        return require("private-next-pages/bimbel/register-trial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimbel/register-trial"])
      });
    }
  